import React from 'react';

import type { ModeReglementsPointageType, ReglementType } from '@/types';

export type ReglementPointageContextType = {
  total: number;
  reglements: ReglementType[];
  sorts: Record<string, 'asc' | 'desc'>;
  loading: boolean;

  setReglements: React.Dispatch<React.SetStateAction<ReglementType[]>>;
  setSorts: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setTotal: React.Dispatch<React.SetStateAction<number>>;
  reset: () => void;
};

// Registry pour stocker tous les contextes créés dynamiquement
export const ReglementPointageContextRegistry = new Map<
  ModeReglementsPointageType,
  React.Context<ReglementPointageContextType | null>
>();

// Fonction pour obtenir ou créer un contexte pour un code donné
export const getReglementPointageContext = (code: ModeReglementsPointageType) => {
  if (!ReglementPointageContextRegistry.has(code)) {
    const newContext = React.createContext<ReglementPointageContextType | null>(null);
    ReglementPointageContextRegistry.set(code, newContext);
  }
  return ReglementPointageContextRegistry.get(code)!;
};

// Pour la compatibilité, on exporte un contexte par défaut (non utilisé)
const ReglementPointageContext = React.createContext<
  Map<ModeReglementsPointageType, ReglementPointageContextType>
>(new Map());

export default ReglementPointageContext;
